import { Link } from "react-router-dom";
import { PropsWithChildren } from "react";
import TwitterIcon from "../../assets/icons/TwitterIcon";
import LinkedInIcon from "../../assets/icons/LinkedInIcon";

const SocialLink = ({ to, children }: PropsWithChildren<{ to: string }>) => (
  <Link
    to={to}
    target="_blank"
    className="flex h-9 w-9 items-center justify-center rounded-full bg-ctb-blue"
  >
    {children}
  </Link>
);

const Footer = () => (
  <footer className="flex w-full flex-col items-center justify-center gap-2 bg-ctb-blue-0 py-8 text-sm font-light leading-[150%] text-ctb-blue">
    <article className="flex gap-4">
      <SocialLink to="https://twitter.com/Capturethebugs">
        <TwitterIcon className="fill-white" />
      </SocialLink>
      <SocialLink to="https://www.linkedin.com/company/capture-the-bug/">
        <LinkedInIcon className="fill-white" />
      </SocialLink>
    </article>

    <span>
      <Link
        target="_blank"
        to="https://capturethebug.xyz/about-us/"
        className="hover:underline"
      >
        About Us
      </Link>{" "}
      •{" "}
      <Link
        target="_blank"
        to="https://capturethebug.xyz/contact-us/"
        className="hover:underline"
      >
        Contact Us
      </Link>
    </span>

    <Link
      to="https://capturethebug.xyz/privacy-policy/"
      className="hover:underline"
      target="_blank"
    >
      Privacy Policy
    </Link>

    <p>&#169; 2023 Capture the Bug</p>
  </footer>
);

export default Footer;
